import { IAdditionalClient, IPlacement, SAME_FOR_BOTH_STR } from "@sp-crm/core";
import { InputFormBlock } from "components/app/input-form-block";
import { Checkbox } from "components/ui/checkbox";
import React, { PureComponent } from "react";
import { Header } from "../../../header";
import ClientDetails from "./client-details";

type MultipleClientsProps = {
    placement: IPlacement;
    additionalClient: IAdditionalClient;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
    onFieldChange: (fieldName: string, newValue: any) => void;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
    onAdditionalClientFieldChange: (fieldName: string, newValue: any) => void;
    onSameForBothClientsCheckboxChanged: (newValue: boolean) => void;
};

class MultipleClients extends PureComponent<MultipleClientsProps> {
    shouldShowBothClientsTogether() {
        return this.props.additionalClient.insuranceAnswersSameAsPrimaryClient;
    }

    getSameForBothClientsCheckbox() {
        return (
            <div>
                <Checkbox
                    onChange={newValue =>
                        this.props.onSameForBothClientsCheckboxChanged(
                            newValue.target.checked,
                        )
                    }
                    checked={
                        this.props.additionalClient.insuranceAnswersSameAsPrimaryClient
                    }
                    label={SAME_FOR_BOTH_STR}
                />
            </div>
        );
    }

    render() {
        return (
            <InputFormBlock>
                <div>
                    <div className="flex justify-between">
                        <div className="header">
                            <Header iconName="53_insurance">
                                Health Insurance Details
                            </Header>
                        </div>
                        {this.getSameForBothClientsCheckbox()}
                    </div>
                </div>
                {this.shouldShowBothClientsTogether() ? (
                    <ClientDetails
                        client={this.props.placement}
                        personaTitle={this.props.placement.formatClientAndAdditionalClientNames()}
                        onFieldChange={this.props.onFieldChange}
                    />
                ) : (
                    <div className="space-y-4">
                        <ClientDetails
                            client={this.props.placement}
                            personaTitle={this.props.placement.formatName(
                                this.props.placement.name,
                            )}
                            onFieldChange={this.props.onFieldChange}
                            additionalClassNames="no-bottom-space"
                        />
                        <ClientDetails
                            client={this.props.additionalClient}
                            personaTitle={this.props.placement.formatName(
                                this.props.additionalClient.name,
                            )}
                            onFieldChange={this.props.onAdditionalClientFieldChange}
                        />
                    </div>
                )}
            </InputFormBlock>
        );
    }
}

export default MultipleClients;
